<template>
  <section>
    <Transition name="fade">
      <div
        class="redirecting"
        v-show="redirecting"
      >
        <div class="container h-100">
          <div class="d-flex h-100">
            <div class="content">
              <img
                src="/build/images/logo-new.png"
                width="200"
                alt="Salesflow CRM"
              >
              <h1>{{ __('Seja bem vindo a melhor plataforma de CRM e Automação de Marketing') }}</h1>
              <p>{{ __('Seu sucesso é o nosso') }}.</p>
              <p>
                <BSpinner
                  type="grow"
                  label="Carregando..."
                />
              </p>
              <p>{{ __('Aguarde, estamos configurando sua conta') }}...</p>
            </div>
          </div>
        </div>
      </div>
    </Transition>
    <main class="main-container">
      <section class="left-section">
        <div class="steps-container">
          <div
            v-for="(description, index) in steps"
            class="step-card"
            :class="{ active: (index + 1) === step, filled: isStepFilled(index + 1), pointer: (index + 1) < step }"
            @click="navigateToStep(index + 1)"
            @mouseover="changeCheckCircleColor(index + 1, '#5F33FF')"
            @mouseout="changeCheckCircleColor(index + 1, '#886AF8')"
          >
            <div class="d-flex align-items-center">
              <CheckCircle
                v-show="isStepFilled(index + 1)"
                :color="checkCircleColor[index + 1]"
              />
              <span class="ml-1"> 0{{ index + 1 }}. </span>
            </div>
            <p> {{ description }} </p>
          </div>
        </div>
      </section>
      <section class="right-section">
        <div class="form-container">
          <img src="/build/images/logo-new.png" alt="Salesflow CRM" width="300">
          <form
            v-if="step === 1"
            @submit.prevent="next()"
          >
            <h2>
              <span v-if="registerForm.name.length >= 3" class="text-break" >{{ __('Olá') }}, {{ firstName }}.</span>
              <span v-else>{{ __('Olá') }}.</span>
            </h2>
            <h3>{{ __('Preencha o formulário abaixo para começar') }}:</h3>
            <div class="form-group">
              <label>{{ __('Nome') }}</label>
              <input
                type="text"
                :placeholder="__('Digite seu nome completo')"
                v-model="registerForm.name"
                required
                maxlength="64"
              />
            </div>
            <div
              class="form-group"
              v-show="! hideEmail || ! isEmail(input.email)"
            >
              <label>{{ __('E-mail') }}</label>
              <input
                type="email"
                :placeholder="__('Digite seu e-mail')"
                v-model="registerForm.email"
                required
                maxlength="84"
              />
              <div
                class="form-text text-danger"
                v-if="registerForm.errors.has('email')"
              >
                {{ registerForm.errors.get('email') }}
              </div>
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label>{{ __('Senha') }}</label>
                <div
                  class="text-danger"
                  style="font-size: 12px; padding-right: 2px; padding-top: 4px;"
                  v-show="registerForm.password.length > 3 && registerForm.password.length < 8"
                >
                  {{ __('Mínimo de 8 caracteres') }}
                </div>
              </div>
              <input
                type="password"
                :placeholder="__('Escolha uma senha')"
                v-model="registerForm.password"
                required
                maxlength="64"
              />
              <div
                class="form-text text-danger"
                v-show="registerForm.errors.has('password')"
              >
                {{ registerForm.errors.get('password') }}
              </div>
            </div>
            <button
              type="submit"
              :disabled="!isButtonDisabled(1)"
              :class="{ disabledButton: !isButtonDisabled(1) }"
            >
              {{ __('Avançar') }}
              <Chevron color="#FFF" :size=8 />
            </button>
          </form>
          <form
            v-if="step === 2"
            @submit.prevent="next()"
            class="d-flex flex-column"
          >
            <h3>{{ __('Boa! Agora vamos falar sobre o seu negócio') }}.</h3>
            <p>{{ __('Nesta etapa esperamos conhecer um pouco mais sobre sua empresa' )}}:</p>
            <div class="form-group">
              <label>{{ __('Qual o nome da sua empresa') }}?</label>
              <input
                type="text"
                :placeholder="__('Nome da empresa')"
                v-model="registerForm.company"
                required
                maxlength="64"
              />
            </div>
            <div class="form-group">
              <label>{{ __('Quantas pessoas trabalham nela') }}?</label>
              <select
                name="select"
                type="text"
                v-model="registerForm.employees"
                autocomplete="false"
                required
              >
                <option value="">
                  {{ __('Selecione') }}
                </option>
                <option value="1 - 5">
                  1 - 5
                </option>
                <option value="6 - 15">
                  6 - 15
                </option>
                <option value="16 - 50">
                  16 - 50
                </option>
                <option value="51 - 100">
                  51 - 100
                </option>
                <option value="100+">
                  100+
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ __('Qual é o site') }}</label>
              <input
                type="text"
                :placeholder="__('Site da empresa')"
                v-model="registerForm.website"
                required
                maxlength="64"
              />
            </div>
            <button
              type="submit"
              :disabled="!isButtonDisabled(2)"
              :class="{ disabledButton: !isButtonDisabled(2) }"
            >
              {{ __('Avançar')}}
              <Chevron color="#FFF" :size=8 />
            </button>
          </form>
          <form
            v-if="step === 3"
            @submit.prevent="next()"
            class="d-flex flex-column"
          >
            <h3>{{ __('Estamos quase lá') }}!</h3>
            <p style="max-width: 65%;">{{ __('Por fim, complete com essas informações abaixo, que iremos direcionar você para nossa plataforma') }}.</p>
            <div class="form-group">
              <label>{{ __('Qual das opções abaixo melhor descreve o seu cargo') }}?</label>
              <select
                class="form-control"
                type="text"
                v-model="registerForm.occupation"
                required
              >
                <option value="">
                  {{ __('Selecione') }}
                </option>
                <option value="C-Level">
                  {{ __('C-Level') }}
                </option>
                <option value="Diretoria">
                  {{ __('Diretoria') }}
                </option>
                <option value="Gerência">
                  {{ __('Gerência') }}
                </option>
                <option value="Marketing">
                  {{ __('Marketing') }}
                </option>
                <option value="Vendedor">
                  {{ __('Vendedor') }}
                </option>
                <option value="Analista">
                  {{ __('Analista') }}
                </option>
                <option value="Estagiário">
                  {{ __('Estagiário') }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ __('Você já utiliza algum software de automação? Se sim, qual') }}?</label>
              <input
                type="text"
                :placeholder="__('Qual?')"
                v-model="registerForm.competitor_mkt"
                required
                maxlength="32"
              >
            </div>
            <div class="form-group">
              <label>{{ __('E de CRM? Se sim, qual') }}?</label>
              <input
                type="text"
                :placeholder="__('Qual?')"
                v-model="registerForm.competitor_crm"
                required
                maxlength="32"
              >
            </div>
            <div class="form-group">
              <label>{{ __('Qual o seu telefone') }}?</label>
              <input
                type="text"
                :placeholder="__('Insira seu número')"
                v-model="registerForm.phone"
                required
                minlength="8"
                oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 16)"
              >
            </div>
            <div class="check-group">
              <input
                type="checkbox"
                id="check-terms"
                v-model="registerForm.terms"
                required
              >
              <label
                for="check-terms"
                class="mb-0 ml-2"
              >
                {{ __('Eu aceito os') }}
                <a
                  href="https://salesflowcrm.movidesk.com/kb/article/405957/termos-de-uso"
                  target="_blank"
                >{{ __('termos de uso') }}</a>
              </label>
            </div>
            <button
              type="submit"
              :disabled="!isButtonDisabled(3) || registerForm.busy"
              :class="{ disabledButton: !isButtonDisabled(3) }"
            >
              {{ __('Acessar minha conta agora') }}
              <BSpinner
                class="ml-1"
                small="small"
                v-if="registerForm.busy"
              />
              <Chevron
                color="#FFF"
                :size=8
                v-show="!registerForm.busy"
              />
            </button>
          </form>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';
import Strings from '../services/strings.js';
import CheckCircle from '../../../resources/js/components/icon/CheckCircle.vue'
// import Chevron from '../../../resources/js/components/icon/Chevron.vue'
import Chevron from '../../../resources/js/components/icon/Chevron.vue'

export default {
  created () {
    if (this.input.name) {
      this.registerForm.name = this.input.name;
    }
    if (this.isEmail(this.input.email)) {
      this.registerForm.email = this.input.email;
    }
    this.registerForm.busy = false;
  },

  props: ['input'],

  components: {
    BSpinner,
    CheckCircle,
    Chevron
  },

  computed: {
    firstName() {
      return this.registerForm.name.split(" ")[0];
    }
  },

  data() {
    return {
      redirecting: false,
      hideEmail: true,
      step: 1,
      steps: [
        this.__('Para iniciar, preencha seus dados pessoais.'),
        this.__('Agora precisamos que você nos conte mais sobre sua empresa, ok?'),
        this.__('E para finalizar, você só precisa preencher as informações complementares.'),
      ],
      registerForm: new BulldeskForm({
        name: '',
        email: '',
        password: '',
        terms: false,
        company: '',
        website: '',
        phone: '',
        employees: '',
        occupation: '',
        competitor_crm: '',
        competitor_mkt: '',
      }),
      checkCircleColor: {
        1: '#886AF8',
        2: '#886AF8',
        3: '#886AF8'
      },
    }
  },

  methods: {
    changeCheckCircleColor(step, color) {
      this.checkCircleColor[step] = color;
    },
    navigateToStep(step) {
      if(this.step > step) {
        this.step = step;
      }
    },
    isButtonDisabled(step) {
      if(step === 1) {
        if(!this.registerForm.name.length || !this.registerForm.email.length || this.registerForm.password.length < 8) {
          return false;
        } else {
          return true
        }
      };

      if(step === 2) {
        if(!this.registerForm.company.length || !this.registerForm.employees.length || !this.registerForm.website.length) {
          return false;
        } else {
          return true;
        }
      };

      if(step === 3) {
        if(!this.registerForm.occupation.length || this.registerForm.phone.length < 8 || !this.registerForm.competitor_crm.length || !this.registerForm.competitor_mkt.length || this.registerForm.terms === false) {
          return false;
        } else {
          return true;
        }
      };
    },
    isStepFilled(step) {
      if(step === 1) {
        if(!this.registerForm.name.length || !this.registerForm.email.length || !this.registerForm.password.length) {
          return false;
        };
      };

      if(step === 2) {
        if(!this.registerForm.company.length || !this.registerForm.employees.length || !this.registerForm.website.length) {
          return false;
        };
      };

      if(step === 3) {
        if(!this.registerForm.occupation.length || !this.registerForm.phone.length || !this.registerForm.competitor_crm.length || !this.registerForm.competitor_mkt.length || this.registerForm.terms === false) {
          return false;
        };
      };

      if(step !== this.step && step < this.step) {
        return true;
      };
    },
    isEmail (email) {
      return Strings.isEmail(email);
    },
    next() {
      // submit if is last step
      if(this.step === 3) {
        return this.submit()
      }
      this.step++
      this.convert(this.step)
    },
    convert (step) {
      if (! this.isEmail(this.registerForm.email)) {
        return;
      }
      this.$http.post('/api/conversion', {
        identifier: `trial_salesflow_step-${step}`,
        token: window.BulldeskSettings.token,
        client: window.BulldeskSettings.client,
        domain: window.BulldeskSettings.domain,
        name: this.registerForm.name,
        email: this.registerForm.email,
        company: this.registerForm.company,
        website: this.registerForm.website,
        phone: this.registerForm.phone,
        employees: this.registerForm.employees,
        occupation: this.registerForm.occupation,
        origin: "Salesflow - início trial",
      });
    },
    submit () {
      this.registerForm.busy = true;
      this.registerForm.errors.forget();
      this.registerForm.locale = this.$lang().getLocale();
      try {
        this.registerForm.bulldesk_client = window.BulldeskSettings.client;
        this.registerForm.bulldesk_domain = window.BulldeskSettings.domain;
      } catch (e) {
        //
      }

      Http.post('/register', this.registerForm)
        .then((response) => {
          this.redirecting = true;
          try {
            gtag('event', 'conversion', { send_to: 'AW-862908766/D03VCJu2qPcBEN7iu5sD' });
            gtag('event', 'sign_up', { send_to: 'AW-862908766/D03VCJu2qPcBEN7iu5sD' });
          } catch (e) {
            console.warn(e);
          }
          try {
            fbq('track', 'StartTrial', { value: 0, currency: 'BRL' });
          } catch (e) {
            console.error(e);
          }
          this.$ga.event('send', {
            hitType: 'button',
            eventCategory: 'conversion',
            eventAction: 'trial-registration',
            eventLabel: 'trial-page',
          });
          setTimeout(() => {
            window.location = response.redirect;
          }, 5000);
        })
        .catch((errors, status) => {
          this.step = 1;
          this.hideEmail = false;
        });
    }
  }
}
</script>

<style scoped>
.redirecting {
  z-index: 9;
  position: absolute;
  background: #fff;
  width: 100%;
  height: 115%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 125% 170%;
  background-image: url(/build/images/auth/redirect@1600.png);
  .container {
    max-width: 90%;
    text-align: center;
    max-width: 600px;
    color: #fff;
  }

  .content {
    margin-top: 4rem;

    img {
      margin-bottom: 11rem;
    }

    h1 {
      font-size: 3rem;
      font-weight: bold;
    }
  }
}

.main-container {
  min-height: 100vh;
  max-width: 100%;
  display: flex;
  font-family: Montserrat;
  color: #242424;
}

.left-section {
  width: 50%;
  background: #886AF8;
  background-image: url('/build/images/auth/bg-register_character.png');
  background-repeat: no-repeat;
  background-position-y: bottom;
  background-position-x: center;
  /* background-size: 70%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.steps-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.step-card {
  display: flex;
  width: 27rem;
  height: 11.25rem;
  padding: 32px 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 16px;
  background: #F5F5F5;
}

.step-card span {
  color: #B7A3FF;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.step-card p {
  color: #AAAAAB;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.active {
  background: #FFF;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.10);

  span {
    color: #886AF8;
  }

  p {
   color: #242424;
  }
}

.filled {
  background: #2CEBA9;

  p,
  span {
    color:  #886AF8;
  }

  &:hover {
    p,
    span {
      color: #5F33FF;
    }

  }
}

.pointer {
  cursor: pointer;
}

.right-section {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 40px;
  padding-right: 40px;
  background-color: #EBEBE8;
}

.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding-left: 80px;
  padding-right: 80px;
}

.form-container img {
  margin-bottom: 24px;
}

.form-container form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 30rem;
}

.form-container form h2 {
  font-size: 28px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 0;
}

.form-container form h3 {
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 0;
}

.form-container form p {
  font-size: 12px;
  line-height: 150%;
  margin-bottom: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.check-group {
  display: flex;
  align-self: start;
  align-items: center;
  justify-content: center;

  label {
    font-weight: 500;
  }

  a {
    color: #886AF8;
    text-decoration: underline;
    font-weight: 600;
  }
}

input[type=checkbox] {
  accent-color:#886AF8 !important;
}

input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.form-container form div label {
  font-size: 12px;
}

.form-container form div input,
.form-container form div select {
  flex: 1;
  padding: 13px 12px;
  line-height: 150%;
  border-radius: 8px;
  border: 1px solid #D1D1D1;
  background: #FFF;
  outline: none;
  font-size: 16px;
}

.form-container form div input::placeholder,
.form-container form div select::placeholder {
  color: #AAAAAB;
}

.form-container form button {
  margin: auto;
  display: flex;
  padding: 12px 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: start;
  border-radius: 14px;
  border: 1px solid #886AF8;
  background: #886AF8;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  color: #FFF;
  outline: none;
}

.form-container form button:hover {
  background: #5F33FF;
}

.form-container form button.disabledButton {
  opacity: 0.6;
}

.form-container form button.disabledButton:hover {
  background: #886AF8;
  opacity: 0.6;
}

@media screen and (max-width: 1600px) {
  .left-section {
    background-size: 65%;
  }

  .steps-container {
    gap: 24px;
  }

  .step-card {
    height: 7.5rem;
    width: 21rem;
    padding: 28px 20px;
    justify-content: center;

    span {
      font-size: 22px;
    }

    p {
      font-size: 14px;
      margin-bottom: 2px;
    }
  }

  .form-container {
    gap: 20px;
  }

  .form-group {
    margin-bottom: 8px;
  }

  .form-container form {
    gap: 12px;
  }

  .form-container form div input,
  .form-container form div select {
    padding: 9px 9px;
    font-size: 12px;
  }

  .form-container form button {
    padding: 10px 24px;
    font-size: 14px;
  }

  .check-group {
    margin-bottom: 4px;
  }
}

@media screen and (max-width: 1366px) {
  .left-section {
    background-size: 60%;
  }

  .steps-container {
    margin-top: -30px;
  }

  .form-container {
    gap: 8px;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .step-card {
    span {
      font-size: 22px;
    }

    p {
      font-size: 14px;
      margin-bottom: 2px;
    }
  }
}

@media screen and (max-width: 1280px) {
  .form-container img {
    margin-bottom: 12px;
    width: 250px;
  }
}

@media screen and (max-width: 1024px){
  .form-container form {
    width: 25rem;
  }
}

@media screen and (min-width: 1280px) and (max-width: 1600px) and (min-height: 900px) and (max-height: 1050px) {
  .step-card {
    height: 10rem;
    width: 27rem;

    span {
      font-size: 26px;
    }

    p {
      font-size: 16px;
      margin-bottom: 2px;
    }
  }

  .form-container {
    gap: 16px;
  }
}
</style>
